var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D7DDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 19.2777L24 23.9999M24 23.9999L15.5 19.2777M24 23.9999L24 33.5M33 28.0585V19.9414C33 19.5988 33 19.4274 32.9495 19.2746C32.9049 19.1395 32.8318 19.0154 32.7354 18.9107C32.6263 18.7924 32.4766 18.7092 32.177 18.5428L24.777 14.4316C24.4934 14.2741 24.3516 14.1953 24.2015 14.1644C24.0685 14.1371 23.9315 14.1371 23.7986 14.1644C23.6484 14.1953 23.5066 14.2741 23.223 14.4316L15.823 18.5428C15.5234 18.7092 15.3737 18.7924 15.2646 18.9107C15.1682 19.0154 15.0951 19.1395 15.0505 19.2746C15 19.4274 15 19.5988 15 19.9414V28.0585C15 28.4012 15 28.5725 15.0505 28.7253C15.0951 28.8605 15.1682 28.9845 15.2646 29.0892C15.3737 29.2076 15.5234 29.2908 15.823 29.4572L23.223 33.5683C23.5066 33.7258 23.6484 33.8046 23.7986 33.8355C23.9315 33.8628 24.0685 33.8628 24.2015 33.8355C24.3516 33.8046 24.4934 33.7258 24.777 33.5683L32.177 29.4572C32.4766 29.2908 32.6263 29.2076 32.7354 29.0892C32.8318 28.9845 32.9049 28.8605 32.9495 28.7253C33 28.5725 33 28.4012 33 28.0585Z",
    stroke: "#0D6CBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.7527df38bab742fe34adf829052b81fb.svg";
export { ForwardRef as ReactComponent };